module.exports = __webpack_public_path__ + "img/fuse-top-spark-2_256x180.66429e61.png";